import { FormattedMessage } from 'components/shared/Intl';
import { useState } from 'react';

import type { TradeButtonProps } from './tradeButtons.confirming.connect';

export function RawTradeButtonsComponent({
  canTrade,
  onTrade,
  onCancel,
  id,
  quoteId,
  tradeLabelKey,
  e2e,
  children,
}: TradeButtonProps) {
  const [hasExecuted, setHasExecuted] = useState(false);
  const onTradeClick = () => {
    setHasExecuted(true);
    onTrade(quoteId);
  };
  const isTradeDisabled = !canTrade || hasExecuted;
  return (
    <div className="d-flex w-100 flex-wrap mt-1">
      {children}
      <button
        className="btn btn-xl w-100 mx-1 btn-info mb-1 mt-2"
        data-e2e={e2e}
        disabled={isTradeDisabled}
        id={id}
        onClick={onTradeClick}
        type="button"
      >
        <FormattedMessage id={tradeLabelKey} />
      </button>
      <button
        className="btn btn-xl mx-1 w-100 btn-light my-1"
        data-e2e="cancel-trade"
        id="btn-cancel-trade"
        onClick={() => onCancel(quoteId)}
        type="button"
      >
        <FormattedMessage id="form.buttons.Cancel" />
      </button>
    </div>
  );
}
